
import { defineComponent, reactive, toRefs, onMounted, Ref } from "vue";
import {
  useOrcamentoService,
  WhatsAppPayloadResponse
} from "../../modules/business/orcamento/orcamentoBusiness";
import { useToast } from "../../modules/message";

interface ModalState {
  payload: WhatsAppPayloadResponse | null;
  loading: boolean;
  loadings: Array<Ref<boolean>>;
}

export default defineComponent({
  setup(props, { emit }) {
    const state = reactive<ModalState>({
      payload: null,
      loading: false,
      loadings: []
    });

    const closeScreen = () => emit("after-close");

    const abrirWhatsApp = () => {
      if (state.payload && state.payload.url) {
        window.open(state.payload.url, "_blank");
      }
    };

    const copiarTexto = () => {
      if (state.payload && state.payload.mensagem) {
        navigator.clipboard.writeText(state.payload.mensagem).then(
          () => useToast().success("Texto copiado"),
          () => useToast().error("Falha ao copiar texto")
        );
      }
    };

    onMounted(() => {
      const { getWhatsAppPayload, data } = useOrcamentoService();
      state.loading = true;
      getWhatsAppPayload(props.idOrcamento)
        .then(() => {
          state.payload = data.value as WhatsAppPayloadResponse;
          state.loading = false;
        })
        .catch(() => {
          state.loading = false;
          closeScreen();
        });
    });

    return {
      closeScreen,
      abrirWhatsApp,
      copiarTexto,
      ...toRefs(state)
    };
  },
  props: {
    idOrcamento: {
      type: Number,
      required: true
    }
  }
});
